import { render } from "./ActivitiesView.vue?vue&type=template&id=fc1f586e"
import script from "./ActivitiesView.vue?vue&type=script&lang=js"
export * from "./ActivitiesView.vue?vue&type=script&lang=js"

import "./ActivitiesView.vue?vue&type=style&index=0&id=fc1f586e&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__